import { TemplateData, TemplateParams } from '.';

const achievementRequestTaskListDenied = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'achievements',
  email: {
    buttonEnabled: true,
    buttonLink: '{{siteUrl}}',
    buttonText: messages.authSignIn,
    content: `
      <p>
        ${messages.achievementRequestTaskListDeniedDescription}
      </p>
      <p>
        {{optionalMessage}}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.emailSignatureText}
      </p>`,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    heading: messages.emailGreeting,
    subject: `{{siteName}}: ${messages.achievementRequestTaskListDenied}`
  },
  placeholders: {
    achievementTitle: {
      label: messages.achievementTitle,
      example: 'Test achievement'
    },
    optionalMessage: {
      label: messages.commonMessageFromAdmin,
      example: 'Here is your achievement.'
    },
    ...defaultPlaceholders
  },
  title: messages.achievementRequestTaskListDenied
});

export default achievementRequestTaskListDenied;
